import { Badge } from '@/components/ui/badge';
import type { SaleStatus } from '@/types/sale';
import { hasKey, useT } from '@/lib/i18n';

const MAP: Record<string, { variant: 'success' | 'warning' | 'destructive' | 'outline'; label: string }> = {
  SUCCESS: { variant: 'success', label: 'Berhasil' },
  SETTLEMENT: { variant: 'success', label: 'Lunas' },
  PENDING: { variant: 'warning', label: 'Menunggu' },
  INITIAL: { variant: 'warning', label: 'Awal' },
  FAILED: { variant: 'destructive', label: 'Gagal' },
  CANCELLED: { variant: 'destructive', label: 'Dibatalkan' },
  REFUND: { variant: 'outline', label: 'Refund' },
};

export function StatusPill({ status }: { status: SaleStatus }) {
  const { t } = useT();
  const cfg = MAP[status] ?? { variant: 'outline' as const, label: String(status) };
  const key = `status.${String(status)}`;
  return <Badge variant={cfg.variant}>{MAP[status] && hasKey(key) ? t(key) : cfg.label}</Badge>;
}
